import { getPrimaryFieldOfPrimaryKey as r, randomCouchString as e } from "rxdb-old2";
import { getJsonExtract as t, isPlainObject as n, PARAM_KEY as o } from "./sqlite-helpers";
var a = ["$or", "$and"];
export function mangoQuerySelectorToSQL(u, s, p, i) {
  var l = r(u.primaryKey);
  return "(" + Object.entries(s).map(([r, s]) => {
    if (!r.startsWith("$")) return n(s) ? mangoQuerySelectorToSQL(u, s, p, r) : (p.push(s), t(l, r) + "=" + o);
    if (a.includes(r)) {
      var c = " " + r.substring(1).toUpperCase() + " ",
        h = s.map(r => mangoQuerySelectorToSQL(u, r, p, i));
      return h.length > 1 ? "(" + h.join(c) + ")" : h.join(c);
    }
    if (!i) throw new Error("cannot have selector operator on the top level " + r);
    switch (r) {
      case "$eq":
        return null === s ? t(l, i) + " IS NULL" : (p.push(s), t(l, i) + "=" + o);
      case "$ne":
        if (null === s) return t(l, i) + " IS NOT NULL";
        p.push(s);
        var m = t(l, i) + "!=" + o;
        return null === s ? m : "(" + m + " OR (" + t(l, i) + " IS NULL))";
      case "$gt":
        return p.push(s), t(l, i) + ">" + o;
      case "$gte":
        return p.push(s), t(l, i) + ">=" + o;
      case "$lt":
        return p.push(s), t(l, i) + "<" + o;
      case "$lte":
        return p.push(s), t(l, i) + "<=" + o;
      case "$exists":
        return s ? (p.push("rand-" + e(10)), t(l, i) + "!=" + o) : t(l, i) + " IS NULL";
      case "$in":
        return s.forEach(r => p.push(r)), t(l, i) + " IN (" + new Array(s.length).fill(o).join(",") + ")";
      case "$nin":
        return p.push(s), t(l, i) + " NOT IN (" + o + ")";
      default:
        var L = new Error("operator " + r + " not implemented");
        throw L.operator = r, L.isNonImplementedOperatorError = !0, L;
    }
  }).join(" AND ") + ")";
}
export function mangoQuerySortToSQL(r, e) {
  return "ORDER BY " + e.map(e => {
    var [n, o] = Object.entries(e)[0];
    return t(r, n) + " " + o.toUpperCase();
  }).join(", ");
}